var _defs, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.715 22.826C36.733 14.277 31.44 5.71 22.893 3.692c-8.546-2.02-17.111 3.275-19.13 11.824-2.017 8.549 3.275 17.116 11.822 19.134 8.547 2.019 17.111-3.275 19.13-11.824z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.598 15.405c0-.208.155-.363.362-.363.156 0 5.284 3.264 5.595 3.471l.828.518a6.75 6.75 0 00.777-.518c.518-.363 5.335-3.471 5.49-3.471.208 0 .363.104.363.363 0 .207-.466.466-.725.621-1.813 1.14-3.678 2.332-5.49 3.472-.104.051-.311.207-.467.207-.155-.052-5.438-3.42-6.37-3.938-.208-.051-.363-.155-.363-.362zm-1.295-.777v9.118c0 .518.363.88.88.88h14.193c.518 0 .88-.414.88-.88v-9.118c0-.519-.31-.985-.88-.985H12.183c-.57 0-.88.466-.88.984z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleLetter);
export default __webpack_public_path__ + "static/media/bubble-letter.ec1c5432.svg";
export { ForwardRef as ReactComponent };